import { render, staticRenderFns } from "./TalentSelect.vue?vue&type=template&id=6d1b543e&"
import script from "./TalentSelect.vue?vue&type=script&lang=js&"
export * from "./TalentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports